import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const styles = xcss({
	display: 'inline-block',
	font: token('font.body'),
	color: 'color.text.subtlest',
	textDecoration: 'none',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});

const SearchMetadataGeneric = ({ label }: { label: string }): React.JSX.Element => {
	return <Box xcss={styles}>{label}</Box>;
};

export default SearchMetadataGeneric;
